import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@assets/images/usercenter/meiyouxiangmu.png';
const _withScopeId = n => (_pushScopeId("data-v-60dc4934"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 1,
  class: "home-box"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "usericon"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "name"
};
const _hoisted_6 = {
  class: "name-info"
};
const _hoisted_7 = {
  key: 0,
  class: "medal"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://s.moimg.net/m/images/user_detail/medal.png"
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-nestmoreweibo"
}, null, -1));
const _hoisted_10 = {
  class: "id"
};
const _hoisted_11 = {
  key: 1,
  class: "attest"
};
const _hoisted_12 = {
  class: "statusInfo"
};
const _hoisted_13 = /*#__PURE__*/_createTextVNode("关注 ");
const _hoisted_14 = /*#__PURE__*/_createTextVNode("粉丝 ");
const _hoisted_15 = {
  key: 2,
  class: "user_content"
};
const _hoisted_16 = {
  class: "nav"
};
const _hoisted_17 = {
  class: "ul"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
  class: "card_info"
};
const _hoisted_20 = /*#__PURE__*/_createTextVNode();
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1));
const _hoisted_22 = ["src"];
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hr"
}, null, -1));
const _hoisted_24 = {
  class: "tab"
};
const _hoisted_25 = {
  class: "li click"
};
const _hoisted_26 = {
  key: 0,
  class: "tab-content"
};
const _hoisted_27 = {
  key: 1,
  class: "tab-content-none"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "这里没有更多的信息", -1));
const _hoisted_30 = [_hoisted_28, _hoisted_29];
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top"
}, null, -1));
const _hoisted_32 = {
  class: "popup-box"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tit"
}, "领取积分", -1));
const _hoisted_34 = {
  class: "tips"
};
const _hoisted_35 = /*#__PURE__*/_createTextVNode("“");
const _hoisted_36 = /*#__PURE__*/_createTextVNode("”送你“");
const _hoisted_37 = /*#__PURE__*/_createTextVNode("”积分，可用于商品折扣、礼品兑换");
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1));
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "去“摩点小程序”领取", -1));
const _hoisted_40 = [_hoisted_38, _hoisted_39];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Error = _resolveComponent("Error");
  const _component_CenterList = _resolveComponent("CenterList");
  const _component_van_popup = _resolveComponent("van-popup");
  return !$data.showError ? (_openBlock(), _createBlock(_component_Error, {
    key: 0,
    message: $data.message
  }, null, 8, ["message"])) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: _normalizeClass(['v', 'v' + $data.user_info.user.vip_type])
  }, null, 2), _createElementVNode("img", {
    src: $data.user_info.user.icon,
    alt: ""
  }, null, 8, _hoisted_4)]), _ctx.userId != $data.toUserid ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [!$data.user_info.is_follow ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "like",
    onClick: _cache[0] || (_cache[0] = $event => $options.like($data.user_info.is_follow))
  }, " + 关注 ")) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "like gray",
    onClick: _cache[1] || (_cache[1] = $event => $options.like($data.user_info.is_follow))
  }, " 已关注 "))], 64)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString($data.user_info.user.nickname), 1), _createElementVNode("div", {
    class: _normalizeClass(['gender', 'gender' + $data.user_info.user.gender])
  }, null, 2), Number($data.user_info.medal_count) > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", null, "勋章" + _toDisplayString($data.user_info.medal_count), 1), _hoisted_9])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_10, "摩点ID： " + _toDisplayString($data.user_info.user.user_id), 1), $data.user_info.user.vip_type != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", {
    class: _normalizeClass(['v', 'v' + $data.user_info.user.vip_type])
  }, null, 2), _createTextVNode(" " + _toDisplayString($data.user_info.user.auth_info), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString($data.user_info.follow_count), 1), _hoisted_13]), _createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString($data.user_info.follower_count), 1), _hoisted_14])]), $data.user_info.user.user_content ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("p", {
    class: _normalizeClass(['p', {
      pall: $data.pall
    }])
  }, [_createTextVNode(_toDisplayString($data.user_info.user.user_content) + " ", 1), $data.user_info.user.user_content.length > 28 ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    onClick: _cache[2] || (_cache[2] = (...args) => $options.clickpall && $options.clickpall(...args))
  }, _toDisplayString(!$data.pall ? "更多" : "收起"), 1)) : _createCommentVNode("", true)], 2), !$data.pall && $data.user_info.user.user_content.length > 28 ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    onClick: _cache[3] || (_cache[3] = (...args) => $options.clickpall && $options.clickpall(...args))
  }, _toDisplayString(!$data.pall ? "更多" : "收起"), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.user_info.cards, (item, idx) => {
    return _openBlock(), _createElementBlock(_Fragment, null, [item.type != 5 && item.type != 4 ? (_openBlock(), _createElementBlock("div", {
      class: "li",
      onClick: $event => $options.cardFn(item),
      key: idx
    }, [_createElementVNode("p", null, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_19, [_createElementVNode("span", null, _toDisplayString(item.num_text), 1), _hoisted_20, _hoisted_21]), _createElementVNode("img", {
      src: `https://s.moimg.net/m/images/user_detail/userCard_${item.type}.png`
    }, null, 8, _hoisted_22)], 8, _hoisted_18)) : _createCommentVNode("", true)], 64);
  }), 256))])])]), _hoisted_23, _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, "发起的众筹 " + _toDisplayString($options.productContent), 1)]), $data.productList.length ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createVNode(_component_CenterList, {
    list: $data.productList,
    onGetlist: $options.getNext
  }, null, 8, ["list", "onGetlist"])])) : (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_30)), _createVNode(_component_van_popup, {
    class: "cp-popup",
    show: $data.showPopup,
    "onUpdate:show": _cache[5] || (_cache[5] = $event => $data.showPopup = $event),
    "close-on-click-overlay": false
  }, {
    default: _withCtx(() => [_hoisted_31, _createElementVNode("div", _hoisted_32, [_hoisted_33, _createElementVNode("div", _hoisted_34, [_hoisted_35, _createElementVNode("strong", null, _toDisplayString($data.user_info.user.nickname || $data.user_info.user.name), 1), _hoisted_36, _createElementVNode("strong", null, _toDisplayString($data.code), 1), _hoisted_37]), _createElementVNode("div", {
      class: "btn",
      onClick: _cache[4] || (_cache[4] = (...args) => $options.goToMina && $options.goToMina(...args))
    }, _hoisted_40)])]),
    _: 1
  }, 8, ["show"])]));
}